export default __webpack_public_path__ + "static/media/dark12.cfe03729.png";